import { type SignupCpfFieldsVariant, isSignupCpfFieldsVariant } from './flag'

// Descriptive union instead of a `birthDateFirst` boolean: the render side reads
// the intent, not a flag (see docs/coding-standards.md, "Avoid boolean prop flags").
export type SignupCpfFieldsFieldOrder = 'cpf_first' | 'birthdate_first'

export interface SignupCpfFieldsLayout {
  showEmailChip: boolean
  showFieldDescriptions: boolean
  fieldOrder: SignupCpfFieldsFieldOrder
}

const LAYOUT_BY_VARIANT = {
  control: {
    showEmailChip: true,
    showFieldDescriptions: false,
    fieldOrder: 'cpf_first',
  },
  a_no_email_chip: {
    showEmailChip: false,
    showFieldDescriptions: false,
    fieldOrder: 'cpf_first',
  },
  b_helper_text: {
    showEmailChip: false,
    showFieldDescriptions: true,
    fieldOrder: 'cpf_first',
  },
  c_dob_first: {
    showEmailChip: false,
    showFieldDescriptions: true,
    fieldOrder: 'birthdate_first',
  },
} as const satisfies Record<SignupCpfFieldsVariant, SignupCpfFieldsLayout>

/**
 * Maps a variant to the layout it renders. Anything that is not a known variant
 * (null, a stale flag value, a hand-typed query param) falls back to control —
 * an unbucketed user must always see production.
 */
export function resolveSignupCpfFieldsLayout(variant: unknown): SignupCpfFieldsLayout {
  return isSignupCpfFieldsVariant(variant) ? LAYOUT_BY_VARIANT[variant] : LAYOUT_BY_VARIANT.control
}
